<template>
  <commodity-derivatives
    :Analytics="Analytics"
    :colorTheme="colorTheme"
    :loadingAll="loadingAll"
    :processData="processData"
    :renderChartSignal="renderChartSignal"
    :isPrices="isPrices"
    :idChart="idChart"
    :asset="Analytics.assetType"
    @changeInfoTable="changeInfoTable"
    @onTableFormat="onHoverChart"
  />
</template>
<script>
import CommodityDerivatives from "./CommodityDerivatives.vue";
import { defaultAnalytics } from "@/_core/data/Analytics/AnalyticsHelpers.js";
export default {
  components: { CommodityDerivatives },
  name: "CommodityPriceDerivatives",
  props: {
    Analytics: {
      required: true,
      default: defaultAnalytics()
    },
    colorTheme: { required: true, type: Boolean, default: true },
    loadingAll: { required: true, type: Boolean, default: false },
    processData: { required: true },
    renderChartSignal: { required: true, default: 0 }
  },
  data() {
    return {
      isPrices: true,
      idChart: "pDerivatives"
    };
  },
  methods: {
    changeInfoTable(val) {
      // console.log("changeInfoTable")
      this.$emit("changeInfoTable", val);
    },
    onHoverChart(val) {
      // console.log("onHoverChart")
      this.$emit("onTableFormat", val);
    }
  }
};
</script>
